define([
    "./VerifyComponentProperty"
], function (VerifyComponentProperty) {
    return (
    {
        warningText: new VerifyComponentProperty({
                type: "string",
                notInAction: false,
                defaultValue: "This component is in Warning state",
                required: false
            }
        )
    }
        );
});
